import React from 'react'
import styles from "./listingsResultAndSort.module.css"
import ListCard from './ListCard'
import SortDropdownComponent from './SortDropdownComponent'
import LinksCard from '../LinksCard'

function index({
    totalListingsCount,
    map,
}:
{
    totalListingsCount:number,
    map?:boolean
}
) {
  return (
    <>
      <div className={styles.listeCarteParent}>
          <ListCard totalListingsCount={totalListingsCount}/>
          <SortDropdownComponent map={map}/>
      </div>
    </>
  )
}

export default index